import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { FuncionarioTabela } from "../../../../domain/models/funcionario_tabela";
import { FuncionarioCopyForm } from "../../../schemas/Funcionarios_lista/copy_funcionario";
import { FuncionarioCopySchema } from "../../../schemas/Funcionarios_lista/copy_funcionario";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";
import { CargoDropDown } from "../../../../../../common/domain/models/cargo_dropdown";

import dayjs from "dayjs";
import { DefaultFormDatePickerInput } from "../../../../../../common/components/default_form_date_picker_input";
import { DefaultFormAutocomplete } from "../../../../../../common/components/default_form_autocomplete";

/**
 * FuncionarioCopyModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedFuncionario: FuncionarioTabela | null;
  cargoDropdown: CargoDropDown[];
  centroCustoDropdown: CentroCustoDropDown[];
  onClose: () => void;
  onSubmit: (form: FuncionarioCopyForm) => void;
};

export const FuncionarioCopyModal = ({
  open,
  saving,
  loading,
  selectedFuncionario,
  cargoDropdown,
  centroCustoDropdown,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<FuncionarioCopyForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(FuncionarioCopySchema)
  });

  useEffect(() => {
    if (open) {
      if (selectedFuncionario) {
        hookForm.reset();
        hookForm.setValue('dataAdmissao', dayjs.utc().toDate());
      }
    }
  }, [
    open,
    selectedFuncionario,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title='Copiar funcionário'
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <div className="flex flex-col gap-4 my-4">
        <DefaultFormDatePickerInput
          name='dataAdmissao'
          label='Data de Admissão'
          required={true}
          reactHookForm={hookForm}
        />

        <DefaultFormAutocomplete
          name='idCentroCusto'
          label='Centro de Custo'
          options={centroCustoDropdown}
          getOptionKey={x => x.id}
          getOptionLabel={x => x.title}
          required={true}
          reactHookForm={hookForm}
        />

        <DefaultFormAutocomplete
          name='idCargo'
          label='Cargo'
          options={cargoDropdown}
          getOptionKey={x => x.idCargo}
          getOptionLabel={x => x.descricao ?? ''}
          required={true}
          reactHookForm={hookForm}
        />
      </div>
    </BaseFormControlledModal>
  );
}